
import type { UniClub as Club } from "../types";

/** Normalise une chaîne (trim, minuscules, espaces réduits) */
function norm(s?: string | null) {
  return (s ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

/** Dédoublonne par (nom + lieu + email + site) après normalisation */
export function dedupeClubs(input: Club[]): Club[] {
  const seen = new Set<string>();
  const out: Club[] = [];
  for (const c of input) {
    const key = [norm(c.nom), norm(c.lieu), norm(c.email ?? ""), norm(c.site ?? "")].join("|");
    if (!seen.has(key)) {
      seen.add(key);
      out.push(c);
    }
  }
  return out;
}
